<div #container
     class="container bg2 page-keyword2">

  <app-header [placeholder]="placeholder"
              [keyHistory]="HistoryKeySearch"
              [keyword]="keyword"
              (search)="onSearch($event)"></app-header>

  <app-left-menu></app-left-menu>

  <section class="about-list">

     <!-- div class="inner wrap {{ forceScroll ? 'detail-open' : '' }}" -->
     <div class="inner wrap">

      <div class="about-list-wrap">

        <ul>

          <li *ngFor="let article of listArticle; let idx = index"
              id="{{ boardSelectId(article) }}">

            <div class="detail-menu"
                 *ngIf="selectNo === article.no">
              <div class="menu-wrap">
                <div class="detail-menu-btn close-btn"
                   (click)="onClose($event)"></div>
              </div>
            </div>


            <a class="{{ article.thumbnail ? '' : 'no-img' }} {{ selectNo === article.no ? 'on' : '' }}"
               (click)="onSelect($event, article)">

              <div class="img-box"
                   *ngIf="article.thumbnail && selectNo !== article.no"> <!-- 썸네일 이미지가 없고, 선택되지 않은 경우 표시 -->
                <img src="{{ ApiUrl(article.thumbnail) }}" alt="이미지">
              </div>

              <div class="subject-box" [innerHTML]="article.title | resize | keepHtml">
              </div>

              <div class="con-box"
                   *ngIf="selectNo !== article.no">
                {{ article.brief }}
              </div>

              <!-- div class="con-box"
                   [@collapse]="selectNo !== article.no"
                   [innerHTML]="ApiUrlReplace(article.content) | keepHtml">
              </div -->
              <!-- 위하고 아래는 엄연히 다르다. 아래는 줄어들기 전에 없어진다.
              위는 없어지는 것이 아니고 줄어들기만 한다. 그리고 생성될 때에도 애니메이션이 재생되므로 곤란하다. -->
              <div class="con-box"
                   *ngIf="selectNo === article.no && selectedArticle" [@collapse]
                   [innerHTML]="ApiUrlReplace(selectedArticle.content) | keepHtml">
              </div>
              <div class="reload-icon" *ngIf="selectNo === article.no && !selectedArticle">
                <img #reload src="assets/img/loading_icon.gif">
              </div>
            </a>
          </li>

          <!-- li>
            <a href="#none" class="no-img">

              <div class="subject-box">
                듣고 배우는 한국어 서비스에 대해서
              </div>

              <div class="con-box">
                이 서비스는 한국어를 사용하는 모든 사람들이 한국어를 정확하게 사용할 수 잇도록 도와서 세줄까지 노출 가능...
                이 서비스는 한국어를 사용하는 모든 사람들이 한국어를 정확하게 사용할 수 잇도록 도와서 세줄까지 노출 가능...
                이 서비스는 한국어를 사용하는 모든 사람들이 한국어를 정확하게 사용할 수 잇도록 도와서 세줄까지 노출 가능...
              </div>

            </a>
          </li -->

          <li *ngIf="listArticle?.length === 0">
            <div class="no-img">
              <div class="img-box">
                <img src="assets/img/img_menu_tiger.svg">
              </div>
              <div class="keyword-no-result-box">
                포함된 글이 없습니다.
              </div>
            </div>
          </li>
        </ul>
      </div>



    </div>
  </section>


  <app-footer></app-footer>

</div>

<app-common-popups></app-common-popups>
